module.exports = __webpack_public_path__ + "static/media/zip-report.4eb31e4b.svg";